<template>
  <div class="translate_result">
    <h1>翻訳結果</h1>
    <div class="result">
        <div class="card-content">
            <div id="id_both">
                <div class="result_word">
                <p id="id" v-if="translate_result.content == translate_result.translated.en">{{translate_result.translated.ja}}</p>
                <p id="id" v-if="translate_result.content == translate_result.translated.ja">{{translate_result.translated.en}}</p>
                <p id="id" v-if="translate_result.content != translate_result.translated.ja && translate_result.content != translate_result.translated.en">{{translate_result.translated.en}}<br>{{translate_result.translated.ja}}</p>
                </div>
                <p class="result_content" id="id">{{translate_result.content}}</p>
            </div>
        </div>
          <span><b-button type="is-text" @click="speech(translate_result.translated.en)"><i class="fas fa-volume-up"></i></b-button></span>
          <span v-if="!translate_result.like"><b-button @click="like(translate_result), translate_result.like = !translate_result.like" type="is-text"><i class="fas fa-star"></i></b-button></span>
          <span v-if="translate_result.like"><b-button type="is-text" disabled><i class="fas fa-star star_like"></i></b-button></span>

        <b-dropdown aria-role="list">
              <button class="button is-text" slot="trigger">
                  <span><i class="far fa-copy"></i></span>
              </button>

              <b-dropdown-item aria-role="listitem" @click="clipboard()">翻訳結果のみコピー</b-dropdown-item>
              <b-dropdown-item aria-role="listitem" @click="clipboardBoth()">両方をコピー</b-dropdown-item>
        </b-dropdown>

        <span><b-button @click="trash(translate_result)" type="is-text"><i class="far fa-trash-alt"></i></b-button></span>
            <div class="icon_description">
                <span><i class="fas fa-volume-up"></i>...発音を聞く </span>
                <span><i class="fas fa-star"></i>...お気に入りに登録 </span>
                <span><i class="far fa-copy"></i>...英文をコピー </span>
                <span><i class="far fa-trash-alt"></i>...削除</span>
            </div>
        <p><b-button class="is-info" icon-left="twitter" @click="twitterShare(translate_result.translated)">Twitterでシェアする</b-button></p>
        <div class="back_page">
        <p><router-link to="/home"><b-button type="is-text" outlined><i class="fas fa-home"></i> ホーム画面へ</b-button></router-link></p>
        <p><router-link to="/write"><b-button type="is-text" outlined><i class="fas fa-edit"></i> 書く画面へ</b-button></router-link></p>
        </div>
    </div>
  </div>
</template>

<script>
import firebase from 'firebase/app'
export default {
    name: 'translate_result',
    data(){
        return{
            translate_result: null,
            test: null
        }
    },
    computed: {
        user(){
            return this.$store.getters.user;
        }
    },
    mounted(){
        const title = "翻訳結果｜メモや日記ついでに英語学習"
        const description = "メモや日記ついでに英語学習の翻訳結果画面です。"
        document.title = title
        document.querySelector("meta[property='og:title']").setAttribute('content', title)
        document.querySelector("meta[name='description']").setAttribute('content', description)
        document.querySelector("meta[property='og:description']").setAttribute('content', description)
    },
    created(){
        firebase.firestore().collection("text").doc(this.$route.params.id).onSnapshot((doc) => {
            var data = doc.data()
            data.id = doc.id
            data.del = false
            data.like = data.like ? data.like : false;
            this.translate_result = data
        });
    },
    methods: {
        speech(speech_text){
        // 発言を作成
        const uttr = new SpeechSynthesisUtterance(speech_text)
        uttr.lang = "en-US"
        // 発言を再生 (発言キューに発言を追加)
        speechSynthesis.speak(uttr)
        },
        like(content){
            firebase.firestore().collection('user').doc(content.uid).collection('like').doc(content.id).set({
                uid: content.uid,
                content: content.content,
                createdAt: content.createdAt,
                createdDay: content.createdDay,
                translated: content.translated 
            },{ merge: true }).then(()=>{
                firebase.firestore().collection('text').doc(content.id).set({
                like: true,
                },{ merge: true })
            }).then(()=>{
                this.$buefy.toast.open('お気に入りに登録しました！')
            }).catch(function() {
                this.$buefy.toast.open('おや？お気に入りの登録に失敗しました');
            })
        },
        trash(){
        var vm = this
        this.$buefy.dialog.confirm({
            message: '削除しますか？',
            onConfirm: () => 
                firebase.firestore().collection('text').doc(this.$route.params.id).delete().then(() => {
                    vm.$buefy.toast.open('削除しました！');
                    this.$router.push({ name: 'write' })
                }).catch(function() {
                    vm.$buefy.toast.open('おや？削除に失敗しました');
            })
        })
        },
        twitterShare(translated){
        var twitter_share_url = 'https://twitter.com/intent/tweet?text=' + translated.en + "%0a%0a" + translated.ja + "%0a%0a" + "%20%23メモ英" + "%20%23メモや日記ついでに英語学習" + "%20" + "https://translate.ameneko.com/"  
        window.open(twitter_share_url, '_blank')  
        },
        clipboard(){
            let range = document.createRange();
            let english_text = document.getElementById('id');
            range.selectNodeContents(english_text);

            //指定した範囲を選択状態にする
            let selection = document.getSelection();
            selection.removeAllRanges();
            selection.addRange(range);

            //コピー
            document.execCommand('copy');
            this.$buefy.toast.open('コピーしました！')
        },
        clipboardBoth(){
            let range = document.createRange();
            let english_text = document.getElementById('id_both');
            range.selectNodeContents(english_text);

            //指定した範囲を選択状態にする
            let selection = document.getSelection();
            selection.removeAllRanges();
            selection.addRange(range);

            //コピー
            document.execCommand('copy');
            this.$buefy.toast.open('コピーしました！')
        }
    }
}
</script>

<style scoped>
h1{
  font-weight: bold;
  font-size: 1.2em;
  text-align: center;
  padding-bottom: 10px;
}
.translate_result{
    max-width: 800px;
    margin:auto;
}
.result{
    text-align: center;
}
.card-content{
    text-align: center;
}
span{
  padding-left:4px;
}
.star_like {
  color: #FFDB49
}
.go_page{
    padding-top:24px;
}
.go_home{
    text-align: center
}
.go_write{
    text-align: center
}
.icon_description{
    padding-top:20px;
    padding-bottom:20px;
    font-size: .7em;

}
.result_word{
    font-size: 1.2em;
    font-weight: bold;
}
.result_content{
    font-size: .8em;
    padding-top:10px;
}
.back_page{
    margin-top:50px;
}
</style>